/**
 * 수금완료 확인창 (구 public/js/m-diary-done.js → BottomSheet → $j.Ui.Dialog)
 *
 * 예상 수주포인트를 보여주고 [수금완료 접수] 를 받는다. 입력칸은 없다 — 작업메모는 어디에도
 * 저장되지 않았고 결제방식(미수/싸인/수금)은 고르든 말든 처리가 같았다(서버가 pay_result='수금' 고정).
 * 받을 것이 없으니 시트가 아니라 확인창이다.
 *
 * 실제 접수는 Diary/Main.js 의 work_done_infos_confirm_Btn_OK() 로 위임한다.
 *
 * [실행 컨텍스트] 상세보기 버튼 HTML 은 /m/ajax/order/{n}/detail-view 가 내려주고
 * 서버렌더되지만 parent.showDetailTableFrameResult() 로 부모 #tempShowBox 에
 * innerHTML 주입된다. 즉 onclick 은 **부모 윈도우**에서 실행되므로 번들과 같은 컨텍스트다.
 * (diary-js-migration.md §3 참조)
 *
 * [레거시 전역 브리지] PHP 인라인 onclick(OrderPolicyService) 호환 — window.work_done_message_show.
 * 경로 B(이벤트 위임) 졸업 시 PHP onclick 제거와 함께 삭제.
 */
export default class PaymentModal {
    constructor() {
        window.work_done_message_show = (...a) => $j.F.Diary.PaymentModal.show(...a);
    }

    /**
     * 수금완료 확인창 열기
     * @param n           호출모드 (2:수금완료) — 접수 함수에 그대로 넘긴다
     * @param pricebefore 결제방식 코드 — 더는 쓰지 않는다. 서버렌더 onclick 서명 유지용
     * @param seldNum     오더번호
     */
    async show(n, pricebefore, seldNum) {
        window.set_selectedNumAgain(seldNum);

        // 수주포인트(15점)는 말하지 않는다 — 다른 적립 행동(현장도착·작업완료·사진 …) 아홉 곳도 창에서
        // 점수를 말하지 않고 원장(/m/point)에서 보인다. 차감(수주취소 200점)만 창에서 알린다.
        const ok = await $j.Ui.Dialog.open({
            title:   '수금완료 할까요?',
            desc:    '발주자에게 수금완료를 알립니다.',
            confirm: '수금완료',
            cancel:  '취소',
        });
        if (ok) window.work_done_infos_confirm_Btn_OK(n);
    }
}
